<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="header">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2">
            <div ref="value">

              <accessible-el-select
                prop="value"
                v-model="form.value"
                allowCreate
                maxlength='100'
                placeholder="Seleccionar"
                :options="values.map((x, index) => ({ id: index, value: x, name: x }))"
                id-prefix="locationgroupingdialog"
              >
                <template #label>
                  <div class="flex items-center">
                    {{headerValue}}
                    <base-tooltip-icon size="sm" :content="'Seleccione una agrupación existente o escriba el nombre de una nueva y selecciónela'" class="ml-2"/>
                  </div>
                </template>
              </accessible-el-select>
              
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" />
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getAgrupacionesNombreLocations } from '@/services/configurations/grouping/getAgrupacionesNombreLocations'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'location-grouping-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    header: {
      type: String,
      default: 'Importante'
    },
    headerValue: {
      type: String,
      default: 'Valor'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      values: [],
      form: {
        value: ''
      },
      rules: {
        value: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      if (value) this.getData()
    },
  },
  mounted: async function () {
    this.getData()
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role'].toLowerCase()
    }
  },
  methods: {
    getData: async function () {
      const dataAgrupaciones = await getAgrupacionesNombreLocations()
      if (dataAgrupaciones.blnError === true) {
        this.doFeedback(dataAgrupaciones.msgError + ' [Código de error: ' + dataAgrupaciones.codError + ']')
      }
      this.values = dataAgrupaciones.Respuesta
    },
    toggleDialog: function () {
      this.form.value = ''
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      // this.values = []
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.form.value)
          this.form.value = ''
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
      // this.values = []
    },
  }
}
</script>

<style lang="scss" scoped></style>
